// extracted by mini-css-extract-plugin
export default {"backButton":"backButtom_backButton__Zgie-"};